var render = function render(){var _vm=this,_c=_vm._self._c;return _c('animated-button',{attrs:{"buttonClass":"btn link-button w-auto d-inline-block","icon":"fa-clipboard t-sm","animatedIcon":"fa-check t-green t-sm","title":"Copy to clipboard"},on:{"click":function($event){$event.stopPropagation();return _vm.onCopy.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }